import { PageHeader } from "@/components/PageHeader";
import { Process } from "@/components/Process";
import { Services } from "@/components/Services";

export default function ServicesPage() {
    return (
        <div data-testid="page-services">
            <PageHeader
                number="P"
                label="Process & Services"
                title="How We Work,"
                accent="What We Deliver."
                text="A collaborative, phase-wise process with element-based costing—and seven end-to-end services from interior design to civil works."
                testid="services-page-header"
            />
            <Process />
            <Services />
        </div>
    );
}
